import { render, staticRenderFns } from "./IcoMinusCircle.vue?vue&type=template&id=35ce3f5b"
import script from "./IcoMinusCircle.vue?vue&type=script&lang=js"
export * from "./IcoMinusCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports